/** Resolve a publication path when the API uses either an absolute URL or same-origin (`''`) base. */
export function artifactPublicationUrl(
  path: string | undefined,
  apiBaseUrl: string,
  browserOrigin: string,
): string | null {
  if (!path) return null
  const base = apiBaseUrl ? new URL(apiBaseUrl, browserOrigin) : new URL(browserOrigin)
  return new URL(path, base).toString()
}
